import { lopBoMonHocSinhActions } from './lopBoMonHocSinhActions';
import { lopBoMonListActions } from './lopBoMonListActions';
import { lopBoMonSoDiemActions } from './lopBoMonSoDiemActions';
export const lopBoMonActionWrapper = {
    lopBoMonList: lopBoMonListActions,
    lopBoMonHocSinh: lopBoMonHocSinhActions,
    lopBoMoSoDiem: lopBoMonSoDiemActions
}